import axios from '../../axios'

/**
 * 查询 签名字串
 * @param {*} data 
 * @returns 
 */
export const getSignStr = data => {
  return axios({
    url: '/graduation/getSignStr',
    method: 'post', data
  })
}
/**
 * 带签章 报名
 * @param {*} data 
 * @returns 
 */
export const reportSign = data => {
  return axios({
    url: '/graduation/reportSign',
    method: 'post', data
  })
}

// 保存
export const save = (data) => {
  return axios({
    url: '/graduation/save',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/graduation/delete',
    method: 'post',
    data
  })
}
// 分页查询
export const findPage = (data) => {
  return axios({
    url: '/graduation/list',
    method: 'post',
    data
  })
}
// 分页查询
export const detailView = (data) => {
  return axios({
    url: '/graduation/detail',
    method: 'post',
    data
  })
}
// 上报
export const report = (data) => {
  return axios({
    url: '/graduation/report',
    method: 'post',
    data
  })
}
// 查看PDF
export const viewPdfBase64 = (data) => {
  return axios({
    url: '/graduation/viewPdf',
    method: 'post',
    data
  })
}
// 结业发送给赵工通知
export const notice = (data) => {
  return axios({
    url: '/graduation/notice',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/graduation/graduation.js